export function Stars({count, total}: {count: number; total: number}) {
  const stars = [];
  const fillUpTo = total > 0 ? count : -1;
  for(let i = 0; i <= 4; i++) {
    stars.push(<i key={i} className={i <= fillUpTo ? "fa fa-star" : "fa fa-star-o"} />);
  }
  return <span className="stars">{stars} ({total})</span>;
}

export function ProductStars({stars, count}: {stars: number; count: number}) {
  return (
    <span className="starsScroll">
      <Stars count={stars} total={count} />
    </span>
  );
}
